import React from 'react';
import ReactDOM from 'react-dom';
import './main.css';
import AppContainer from './components/_App/AppContainer';
import registerServiceWorker from './registerServiceWorker';

import { Provider } from 'react-redux';
import { store } from './components/_App/redux';

console.disableYellowBox = true;

ReactDOM.render(
  <Provider store={store}>
    <AppContainer>
    </AppContainer>
  </Provider>,
  document.getElementById('root')
);

registerServiceWorker();